import React from "react";
import { Helmet } from "react-helmet-async";
import "./SEOPage.css";

const SEOPage = ({
  title,
  description,
  canonical,
  heading,
  focusKeyword,
}) => {
  return (
    <>
      <Helmet>
        <title>{title}</title>

        <meta name="description" content={description} />

        <meta
          name="keywords"
          content={`
          ${focusKeyword},
          Best IVF Centre in Ambala,
          IVF Treatment in Ambala,
          Fertility Clinic in Ambala,
          IVF Specialist in Ambala,
          IUI Treatment in Ambala,
          ICSI Treatment in Ambala,
          Male Infertility Treatment,
          Female Infertility Treatment,
          Test Tube Baby Centre in Ambala,
          Gynaecologist in Ambala,
          Pediatrics Doctor in Ambala,
          Dietician in Ambala,
          Pregnancy Care,
          PCOS Treatment,
          High Risk Pregnancy,
          Test Tube Baby Treatment,
          Fertility Specialist,
          IVF Success Rate
        `}
        />

        <link rel="canonical" href={canonical} />
      </Helmet>

      <div className="seo-page">

        {/* HERO SECTION */}

        <section className="seo-hero">
          <div className="container">

            <h1>{heading}</h1>

            <p>
              Amaanat IVF Clinic is one of the most trusted fertility clinics in
              Ambala offering advanced IVF, IUI, ICSI, Gynaecology,
              Pediatrics and Dietician services under one roof.
            </p>

            <a
              href="/bookappointment"
              className="hero-btn text-decoration-none d-inline-block"
            >
              Book Appointment
            </a>

          </div>
        </section>

        {/* STATS */}

        <section className="stats-section container">
          <div className="row">

            <div className="col-md-3 mb-4">
              <div className="stat-card">
                <h3>5000+</h3>
                <p>Happy Families</p>
              </div>
            </div>

            <div className="col-md-3 mb-4">
              <div className="stat-card">
                <h3>15+</h3>
                <p>Years Experience</p>
              </div>
            </div>

            <div className="col-md-3 mb-4">
              <div className="stat-card">
                <h3>80%</h3>
                <p>Success Rate</p>
              </div>
            </div>

            <div className="col-md-3 mb-4">
              <div className="stat-card">
                <h3>24x7</h3>
                <p>Patient Support</p>
              </div>
            </div>

          </div>
        </section>

        {/* INTRO */}

        <section className="content-section">
          <div className="container">

            <h2>{focusKeyword}</h2>

            <p>
              Amaanat IVF Clinic is dedicated to helping couples overcome
              infertility and achieve their dream of becoming parents.
              Our experienced fertility specialists provide personalized
              treatment plans using modern reproductive technologies and
              evidence-based fertility treatments.
            </p>

            <p>
              Whether you are seeking IVF Treatment in Ambala, IUI Treatment,
              ICSI Treatment, Female Infertility Treatment or Male Infertility
              Treatment, our multidisciplinary team is committed to providing
              compassionate and effective fertility care.
            </p>

          </div>
        </section>

        {/* SERVICES */}

        <section className="content-section bg-white">
          <div className="container">

            <h2>Our Fertility & Healthcare Services</h2>

            <div className="row">

              <div className="col-md-4 mb-4">
                <div className="service-card">
                  <h4>IVF Treatment</h4>
                  <p>
                    Advanced IVF procedures with state-of-the-art laboratory
                    support and personalized treatment plans.
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="service-card">
                  <h4>IUI Treatment</h4>
                  <p>
                    Cost-effective fertility treatment option for couples
                    experiencing infertility.
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="service-card">
                  <h4>ICSI Treatment</h4>
                  <p>
                    Advanced fertility treatment designed for severe male
                    infertility cases.
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="service-card">
                  <h4>Gynaecology</h4>
                  <p>
                    Comprehensive women's healthcare including PCOS,
                    infertility evaluation and pregnancy care.
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="service-card">
                  <h4>Pediatrics</h4>
                  <p>
                    Complete child healthcare services including vaccination,
                    newborn care and growth monitoring.
                  </p>
                </div>
              </div>

              <div className="col-md-4 mb-4">
                <div className="service-card">
                  <h4>Dietician Consultation</h4>
                  <p>
                    Specialized fertility nutrition, pregnancy diet planning
                    and PCOS nutrition management.
                  </p>
                </div>
              </div>

            </div>

          </div>
        </section>

        {/* WHY CHOOSE */}

        <section className="content-section">
          <div className="container">

            <h2>Why Choose Amaanat IVF Clinic?</h2>

            <ul className="seo-list">
              <li>Experienced Fertility Specialists</li>
              <li>Modern IVF Laboratory</li>
              <li>Advanced Reproductive Technologies</li>
              <li>Affordable IVF Packages</li>
              <li>Personalized Fertility Care</li>
              <li>High IVF Success Rates</li>
              <li>Comprehensive Women's Healthcare</li>
              <li>Pediatrics & Dietician Services</li>
            </ul>

          </div>
        </section>

        {/* IVF PROCESS */}

        <section className="content-section bg-white">
          <div className="container">

            <h2>IVF Treatment Process</h2>

            <div className="timeline">

              <div className="timeline-item">
                <h5>1. Initial Consultation</h5>
                <p>Complete fertility assessment and treatment planning.</p>
              </div>

              <div className="timeline-item">
                <h5>2. Ovarian Stimulation</h5>
                <p>Medication is used to stimulate egg production.</p>
              </div>

              <div className="timeline-item">
                <h5>3. Egg Retrieval</h5>
                <p>Healthy mature eggs are collected.</p>
              </div>

              <div className="timeline-item">
                <h5>4. Fertilization</h5>
                <p>Eggs are fertilized in our IVF laboratory.</p>
              </div>

              <div className="timeline-item">
                <h5>5. Embryo Transfer</h5>
                <p>Selected embryos are transferred into the uterus.</p>
              </div>

            </div>

          </div>
        </section>

        {/* FAQ */}

        <section className="content-section">
          <div className="container">

            <h2>Frequently Asked Questions</h2>

            <div className="faq-item">
              <h5>What is IVF Treatment?</h5>
              <p>
                IVF is a fertility treatment where eggs and sperm are combined
                outside the body and embryos are transferred into the uterus.
              </p>
            </div>

            <div className="faq-item">
              <h5>Who needs IVF?</h5>
              <p>
                Couples facing infertility due to male factors, female factors,
                blocked tubes, PCOS or unexplained infertility may benefit.
              </p>
            </div>

            <div className="faq-item">
              <h5>Do you provide Gynaecology services?</h5>
              <p>
                Yes. We offer PCOS treatment, pregnancy care, infertility
                evaluation and women's healthcare.
              </p>
            </div>

            <div className="faq-item">
              <h5>Do you provide Pediatrics care?</h5>
              <p>
                Yes. We provide newborn care, vaccination services and child
                healthcare consultations.
              </p>
            </div>

          </div>
        </section>

        {/* CTA */}

        <section className="container pb-5">
          <div className="cta-section">

            <h2>Start Your Parenthood Journey Today</h2>

            <p>
              Meet our fertility experts and get personalized treatment plans
              tailored to your needs.
            </p>

            <a
              href="/bookappointment"
              className="cta-btn text-decoration-none d-inline-block"
            >
              Schedule Consultation
            </a>

          </div>
        </section>
{/* HARYANA COVERAGE SECTION */}

<section className="content-section bg-white">
  <div className="container">

    <h2>
      Serving Patients Across Haryana from Our Ambala IVF Centre
    </h2>

    <p>
      Located in Ambala, Amaanat IVF Clinic welcomes patients from across
      Haryana who are seeking advanced fertility treatments, IVF, IUI, ICSI,
      infertility management, pregnancy care, gynaecology services,
      pediatrics consultations and fertility nutrition guidance.
    </p>

    <p>
      Many couples travel to our Ambala fertility centre because of our
      experienced IVF specialists, advanced laboratory facilities,
      personalized treatment plans and compassionate patient care.
    </p>

    <div className="row mt-5">

      <div className="col-lg-4 col-md-6 mb-4">
        <div className="service-card">
          <h4>Patients from Kurukshetra</h4>
          <p>
            Couples from Kurukshetra visit our Ambala IVF centre for IVF,
            IUI, ICSI and infertility treatment.
          </p>
        </div>
      </div>

      <div className="col-lg-4 col-md-6 mb-4">
        <div className="service-card">
          <h4>Patients from Yamunanagar</h4>
          <p>
            Our fertility specialists regularly assist patients from
            Yamunanagar seeking fertility evaluation and reproductive care.
          </p>
        </div>
      </div>

      <div className="col-lg-4 col-md-6 mb-4">
        <div className="service-card">
          <h4>Patients from Panchkula</h4>
          <p>
            Advanced IVF and fertility solutions for families travelling
            from Panchkula to Ambala.
          </p>
        </div>
      </div>

      <div className="col-lg-4 col-md-6 mb-4">
        <div className="service-card">
          <h4>Patients from Karnal</h4>
          <p>
            Fertility consultations, IVF treatment and infertility
            management for patients from Karnal.
          </p>
        </div>
      </div>

      <div className="col-lg-4 col-md-6 mb-4">
        <div className="service-card">
          <h4>Patients from Kaithal</h4>
          <p>
            Affordable fertility treatment options and personalized care
            for patients from Kaithal.
          </p>
        </div>
      </div>

      <div className="col-lg-4 col-md-6 mb-4">
        <div className="service-card">
          <h4>Patients from Panipat</h4>
          <p>
            Comprehensive IVF, IUI and infertility treatment services for
            patients travelling from Panipat.
          </p>
        </div>
      </div>

    </div>

    <div className="mt-5">

      <h3>
        Fertility Services Available at Our Ambala Clinic
      </h3>

      <p>
        Our Ambala IVF centre provides comprehensive fertility and women's
        healthcare services including:
      </p>

      <div className="row">

        <div className="col-md-6">
          <ul className="seo-list">
            <li>IVF Treatment</li>
            <li>IUI Treatment</li>
            <li>ICSI Treatment</li>
            <li>Male Infertility Treatment</li>
            <li>Female Infertility Treatment</li>
            <li>Egg Donation Programs</li>
          </ul>
        </div>

        <div className="col-md-6">
          <ul className="seo-list">
            <li>Embryo Transfer</li>
            <li>Pregnancy Care</li>
            <li>Gynaecology Services</li>
            <li>Pediatrics Care</li>
            <li>Dietician Consultation</li>
            <li>PCOS Management</li>
          </ul>
        </div>

      </div>

    </div>

  </div>
</section>
      </div>
    </>
  );
};

export default SEOPage;